import { Localized } from "@fluent/react";
import { LoadingButton } from "@mui/lab";
import SyncIcon from '@mui/icons-material/Sync';

interface GenerateButtonProps {
    loading: boolean;
    isDisabled?: boolean;
    onClick: () => void;
}

export const GenerateButton: React.FC<GenerateButtonProps> = ({ loading, onClick, isDisabled }) => {
    return (
        <LoadingButton
            loading={loading}
            size="small"
            color="info"
            variant="contained"
            disabled={isDisabled}
            onClick={onClick}
            startIcon={<SyncIcon />}
        >
            <Localized id="generate">_generuj</Localized>
        </LoadingButton>
    );
};
